<template>
  <div class="display-wrapper fullscreen-wrapper">
    <fullscreen :fullscreen.sync="isFullscreen" style="background-color: #101129 !important;">
      <div class="display-content" v-if="isShowChild" style="position:relative">
        <div
          style="
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 35px;
                left: 0;
              "
        >
              <span @click="toggleApi" style="margin-right:2rem">
                <span class="fullscreen-btn" v-if="!fullscreen">全屏</span>
                <span class="fullscreen-btn" v-else>退出全屏</span>
              </span>
          <span @click="goback">
                <span class="fullscreen-btn">返回首页</span>
              </span>
        </div>
        <div
          style="
                width: 98%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 85px;
                left: 25px;
              "
        >
          <button class="cool-button" @click="goData">综合数据</button>
          <button class="cool-button" @click="goSchool" >体教融合</button>
          <button class="cool-button-active" >组织架构</button>
          <button class="cool-button" @click="goSite" >基础设施</button>
          <button class="cool-button" @click="goKeyCity">重点城市</button>
        </div>
        <!--组织架构数据大屏展示-->
        <div class="column">
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">上海申花足球俱乐部</div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['申花'].youth.banner || clubImg" @error="statisticsOrganizational['申花'].youth.banner = clubImg" style="width:110px;height:110px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['申花'].youth.organShortName)" style="color:#ffbd57">{{statisticsOrganizational['申花'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['申花'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['申花'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['申花'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['申花'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['申花'].youth.cityName}}{{statisticsOrganizational['申花'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['申花'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['申花'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['申花'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['申花'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['申花'].youthHeader.linkman}} {{statisticsOrganizational['申花'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">上海海港足球俱乐部有限公司</div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['海港'].youth.banner  || clubImg" @error="statisticsOrganizational['海港'].youth.banner = clubImg" style="width:110px;height:110px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['海港'].youth.organShortName)" style="color:#ffbd57">{{statisticsOrganizational['海港'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['海港'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['海港'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['海港'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['海港'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['海港'].youth.cityName}}{{statisticsOrganizational['海港'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['海港'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['海港'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['海港'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['海港'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['海港'].youthHeader.linkman}} {{statisticsOrganizational['海港'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">
                上海根宝足球基地有限公司
                <ul class="stars">
                  <li class="not_edit" v-for="(item,index) in starsList_three" :key="index" >
                    <v-icon class="icon" v-if="item.checked" name="star" scale="1"></v-icon>
                    <v-icon class="icon" v-else name="regular/star" scale="1"></v-icon>
                  </li>
                </ul>
              </div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['根宝基地'].youth.banner  || clubImg" @error="statisticsOrganizational['根宝基地'].youth.banner = clubImg" style="width:110px;height:110px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['根宝基地'].youth.organShortName)" style="color:#ffbd57">{{statisticsOrganizational['根宝基地'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['根宝基地'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['根宝基地'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['根宝基地'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['根宝基地'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['根宝基地'].youth.cityName}}{{statisticsOrganizational['根宝基地'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['根宝基地'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['根宝基地'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['根宝基地'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['根宝基地'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['根宝基地'].youthHeader.linkman}} {{statisticsOrganizational['根宝基地'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">上海市体育运动学校
                <ul class="stars">
                  <li class="not_edit" v-for="(item,index) in starsList_three" :key="index" >
                    <v-icon class="icon" v-if="item.checked" name="star" scale="1"></v-icon>
                    <v-icon class="icon" v-else name="regular/star" scale="1"></v-icon>
                  </li>
                </ul>
              </div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['市体校'].youth.banner  || clubImg" @error="statisticsOrganizational['市体校'].youth.banner = clubImg" style="width:110px;height:110px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['市体校'].youth.organShortName)" style="color:#ffbd57">{{statisticsOrganizational['市体校'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['市体校'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['市体校'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['市体校'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['市体校'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['市体校'].youth.cityName}}{{statisticsOrganizational['市体校'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['市体校'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['市体校'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['市体校'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['市体校'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['市体校'].youthHeader.linkman}} {{statisticsOrganizational['市体校'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="column">
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">上海市杨浦区青少年业余体育学校
                <ul class="stars">
                  <li class="not_edit" v-for="(item,index) in starsList_five" :key="index" >
                    <v-icon class="icon" v-if="item.checked" name="star" scale="1"></v-icon>
                    <v-icon class="icon" v-else name="regular/star" scale="1"></v-icon>
                  </li>
                </ul>
              </div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['杨浦少体校'].youth.banner || clubImg" @error="statisticsOrganizational['杨浦少体校'].youth.banner = clubImg" style="width:110px;height:110px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['杨浦少体校'].youth.organShortName)">{{statisticsOrganizational['杨浦少体校'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['杨浦少体校'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['杨浦少体校'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['杨浦少体校'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['杨浦少体校'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['杨浦少体校'].youth.cityName}}{{statisticsOrganizational['杨浦少体校'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['杨浦少体校'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['杨浦少体校'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['杨浦少体校'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['杨浦少体校'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['杨浦少体校'].youthHeader.linkman}} {{statisticsOrganizational['杨浦少体校'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">上海市普陀区青少年足球学校
                <ul class="stars">
                  <li class="not_edit" v-for="(item,index) in starsList_five" :key="index" >
                    <v-icon class="icon" v-if="item.checked" name="star" scale="1"></v-icon>
                    <v-icon class="icon" v-else name="regular/star" scale="1"></v-icon>
                  </li>
                </ul>
              </div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['普陀足校'].youth.banner || clubImg" @error="statisticsOrganizational['普陀足校'].youth.banner = clubImg" style="width:110px;height:110px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['普陀足校'].youth.organShortName)">{{statisticsOrganizational['普陀足校'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['普陀足校'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['普陀足校'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['普陀足校'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['普陀足校'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['普陀足校'].youth.cityName}}{{statisticsOrganizational['普陀足校'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['普陀足校'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['普陀足校'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['普陀足校'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['普陀足校'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['普陀足校'].youthHeader.linkman}} {{statisticsOrganizational['普陀足校'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">上海市静安区青少年体育训练管理中心
                <ul class="stars">
                  <li class="not_edit" v-for="(item,index) in starsList_five" :key="index" >
                    <v-icon class="icon" v-if="item.checked" name="star" scale="1"></v-icon>
                    <v-icon class="icon" v-else name="regular/star" scale="1"></v-icon>
                  </li>
                </ul>
              </div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['静安青训中心'].youth.banner || clubImg" @error="statisticsOrganizational['静安青训中心'].youth.banner = clubImg" style="width:110px;height:110px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['静安青训中心'].youth.organShortName)">{{statisticsOrganizational['静安青训中心'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['静安青训中心'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['静安青训中心'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['静安青训中心'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['静安青训中心'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['静安青训中心'].youth.cityName}}{{statisticsOrganizational['静安青训中心'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['静安青训中心'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['静安青训中心'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['静安青训中心'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['静安青训中心'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['静安青训中心'].youthHeader.linkman}} {{statisticsOrganizational['静安青训中心'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">上海嘉定汇龙足球俱乐部有限公司
                <ul class="stars">
                  <li class="not_edit" v-for="(item,index) in starsList_four" :key="index" >
                    <v-icon class="icon" v-if="item.checked" name="star" scale="1"></v-icon>
                    <v-icon class="icon" v-else name="regular/star" scale="1"></v-icon>
                  </li>
                </ul>
              </div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['嘉定汇龙'].youth.banner || clubImg" @error="statisticsOrganizational['嘉定汇龙'].youth.banner = clubImg" style="width:110px;height:110px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['嘉定汇龙'].youth.organShortName)">{{statisticsOrganizational['嘉定汇龙'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['嘉定汇龙'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['嘉定汇龙'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['嘉定汇龙'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['嘉定汇龙'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['嘉定汇龙'].youth.cityName}}{{statisticsOrganizational['嘉定汇龙'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['嘉定汇龙'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['嘉定汇龙'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['嘉定汇龙'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['嘉定汇龙'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['嘉定汇龙'].youthHeader.linkman}} {{statisticsOrganizational['嘉定汇龙'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="column">
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">上海国王向上培训学校有限公司
                <ul class="stars">
                  <li class="not_edit" v-for="(item,index) in starsList_four" :key="index" >
                    <v-icon class="icon" v-if="item.checked" name="star" scale="1"></v-icon>
                    <v-icon class="icon" v-else name="regular/star" scale="1"></v-icon>
                  </li>
                </ul>
              </div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['国王向上'].youth.banner  || clubImg" @error="statisticsOrganizational['国王向上'].youth.banner = clubImg" style="width:110px;height:110px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['国王向上'].youth.organShortName)">{{statisticsOrganizational['国王向上'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['国王向上'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['国王向上'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['国王向上'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['国王向上'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['国王向上'].youth.cityName}}{{statisticsOrganizational['国王向上'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['国王向上'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['国王向上'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['国王向上'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['国王向上'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['国王向上'].youthHeader.linkman}} {{statisticsOrganizational['国王向上'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">上海幸运星足球俱乐部有限公司
                <ul class="stars">
                  <li class="not_edit" v-for="(item,index) in starsList_four" :key="index" >
                    <v-icon class="icon" v-if="item.checked" name="star" scale="1"></v-icon>
                    <v-icon class="icon" v-else name="regular/star" scale="1"></v-icon>
                  </li>
                </ul>
              </div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['幸运星'].youth.banner  || clubImg" @error="statisticsOrganizational['幸运星'].youth.banner = clubImg" style="width:110px;height:110px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['幸运星'].youth.organShortName)">{{statisticsOrganizational['幸运星'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['幸运星'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['幸运星'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['幸运星'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['幸运星'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['幸运星'].youth.cityName}}{{statisticsOrganizational['幸运星'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['幸运星'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['幸运星'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['幸运星'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['幸运星'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['幸运星'].youthHeader.linkman}} {{statisticsOrganizational['幸运星'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">上海吉祥足球运动俱乐部
                <ul class="stars">
                  <li class="not_edit" v-for="(item,index) in starsList_four" :key="index" >
                    <v-icon class="icon" v-if="item.checked" name="star" scale="1"></v-icon>
                    <v-icon class="icon" v-else name="regular/star" scale="1"></v-icon>
                  </li>
                </ul>
              </div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['吉祥'].youth.banner  || clubImg" @error="statisticsOrganizational['吉祥'].youth.banner = clubImg" style="width:110px;height:110px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['吉祥'].youth.organShortName)">{{statisticsOrganizational['吉祥'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['吉祥'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['吉祥'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['吉祥'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['吉祥'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['吉祥'].youth.cityName}}{{statisticsOrganizational['吉祥'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['吉祥'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['吉祥'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['吉祥'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['吉祥'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['吉祥'].youthHeader.linkman}} {{statisticsOrganizational['吉祥'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">上海市金山区体育中心
                <ul class="stars">
                  <li class="not_edit" v-for="(item,index) in starsList_four" :key="index" >
                    <v-icon class="icon" v-if="item.checked" name="star" scale="1"></v-icon>
                    <v-icon class="icon" v-else name="regular/star" scale="1"></v-icon>
                  </li>
                </ul>
              </div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['金山体育中心'].youth.banner || clubImg" @error="statisticsOrganizational['金山体育中心'].youth.banner = clubImg" style="width:120px;height:80px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['金山体育中心'].youth.organShortName)">{{statisticsOrganizational['金山体育中心'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['金山体育中心'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['金山体育中心'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['金山体育中心'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['金山体育中心'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['金山体育中心'].youth.cityName}}{{statisticsOrganizational['金山体育中心'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['金山体育中心'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['金山体育中心'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['金山体育中心'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['金山体育中心'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['金山体育中心'].youthHeader.linkman}} {{statisticsOrganizational['金山体育中心'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="column">
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">上海优体足球俱乐部
                <ul class="stars">
                  <li class="not_edit" v-for="(item,index) in starsList_three" :key="index" >
                    <v-icon class="icon" v-if="item.checked" name="star" scale="1"></v-icon>
                    <v-icon class="icon" v-else name="regular/star" scale="1"></v-icon>
                  </li>
                </ul>
              </div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['优体'].youth.banner  || clubImg" @error="statisticsOrganizational['优体'].youth.banner = clubImg" style="width:110px;height:110px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['优体'].youth.organShortName)">{{statisticsOrganizational['优体'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['优体'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['优体'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['优体'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['优体'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['优体'].youth.cityName}}{{statisticsOrganizational['优体'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['优体'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['优体'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['优体'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['优体'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['优体'].youthHeader.linkman}} {{statisticsOrganizational['优体'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">上海竞达足球俱乐部有限公司
                <ul class="stars">
                  <li class="not_edit" v-for="(item,index) in starsList_three" :key="index" >
                    <v-icon class="icon" v-if="item.checked" name="star" scale="1"></v-icon>
                    <v-icon class="icon" v-else name="regular/star" scale="1"></v-icon>
                  </li>
                </ul>
              </div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['竞达'].youth.banner  || clubImg" @error="statisticsOrganizational['竞达'].youth.banner = clubImg" style="width:110px;height:110px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['竞达'].youth.organShortName)">{{statisticsOrganizational['竞达'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['竞达'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['竞达'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['竞达'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['竞达'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['竞达'].youth.cityName}}{{statisticsOrganizational['竞达'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['竞达'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['竞达'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['竞达'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['竞达'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['竞达'].youthHeader.linkman}} {{statisticsOrganizational['竞达'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">上海捷希青少年足球俱乐部有限公司
                <ul class="stars">
                  <li class="not_edit" v-for="(item,index) in starsList_three" :key="index" >
                    <v-icon class="icon" v-if="item.checked" name="star" scale="1"></v-icon>
                    <v-icon class="icon" v-else name="regular/star" scale="1"></v-icon>
                  </li>
                </ul>
              </div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['捷希'].youth.banner  || clubImg" @error="statisticsOrganizational['捷希'].youth.banner = clubImg" style="width:110px;height:110px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['捷希'].youth.organShortName)">{{statisticsOrganizational['捷希'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['捷希'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['捷希'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['捷希'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['捷希'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['捷希'].youth.cityName}}{{statisticsOrganizational['捷希'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['捷希'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['捷希'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['捷希'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['捷希'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['捷希'].youthHeader.linkman}} {{statisticsOrganizational['捷希'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row class-all">
            <div class="row-content" style="padding: 1.25rem">
              <div class="row-title">上海市浦东新区第一少年儿童体育学校
                <ul class="stars">
                  <li class="not_edit" v-for="(item,index) in starsList_three" :key="index" >
                    <v-icon class="icon" v-if="item.checked" name="star" scale="1"></v-icon>
                    <v-icon class="icon" v-else name="regular/star" scale="1"></v-icon>
                  </li>
                </ul>
              </div>
              <div class="data-wrapper" style="position: relative">
                <div class="data-wrapper" style="display:flex;font-size:16px">
                  <div style="margin-top:1rem;align-self: center;">
                    <img :src="statisticsOrganizational['浦东一少体'].youth.banner || clubImg" @error="statisticsOrganizational['浦东一少体'].youth.banner = clubImg" style="width:110px;height:110px">
                  </div>
                  <div style="margin-top:1rem;margin-left:2rem;line-height: 25px; color:#4C9BFD">
                    <p>
                        <span>
                          管理单位：
                          <span v-if="['市直属'].includes(statisticsOrganizational['浦东一少体'].youth.organShortName)">{{statisticsOrganizational['浦东一少体'].youth.organShortName}}</span>
                          <span v-else-if="['浦东新区'].includes(statisticsOrganizational['浦东一少体'].youth.organShortName)">浦东新区体育管理指导中心</span>
                          <span v-else>{{statisticsOrganizational['浦东一少体'].youth.organShortName}}体育局</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          地址：
                          <span v-if="statisticsOrganizational['浦东一少体'].youth.uuid ==='b04aa53a719343ddb8880e2e56da676d'">绿舟基地（上海市青浦区）</span>
                          <span v-else-if="statisticsOrganizational['浦东一少体'].youth.uuid ==='671c6ca6df5d41f1af79bdde91aefb03'">康桥基地（上海市浦东新区）</span>
                          <span v-else> {{statisticsOrganizational['浦东一少体'].youth.cityName}}{{statisticsOrganizational['浦东一少体'].youth.countyName}}</span>
                        </span>
                    </p>
                    <p>
                        <span>
                          法人：{{statisticsOrganizational['浦东一少体'].youthHeader.juridicalPerson}}
                        </span>
                    </p>
                    <p>
                        <span>
                          机构负责人：{{statisticsOrganizational['浦东一少体'].youthHeader.youthHeader}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监：{{statisticsOrganizational['浦东一少体'].youthHeader.youthDirectorName}}
                        </span>
                    </p>
                    <p>
                        <span>
                          青训总监教练证书：{{statisticsOrganizational['浦东一少体'].youthHeader.youthDirectorLevel}}
                        </span>
                    </p>
                    <p>
                        <span>
                          联络人：{{statisticsOrganizational['浦东一少体'].youthHeader.linkman}} {{statisticsOrganizational['浦东一少体'].youthHeader.linkmanPhone}}
                        </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </fullscreen>
  </div>
</template>

<script>
  import VueFullscreen from "vue-fullscreen";
  import Vue from "vue";
  import  statistics  from "@/api/statistics";
  import yiyi from '@/assets/images/common/yioks_yiyi1.png'
  import keke from '@/assets/images/common/yioks_keke2.png'
  import clubImg from '@/assets/images/common/club.png'
  import "vue-awesome/icons/star"
  import "vue-awesome/icons/regular/star"
  Vue.use(VueFullscreen);

  export default {
    data() {
      return {
        yiyi,
        keke,
        clubImg,
        fullscreen: false,
        isFullscreen: false,
        toReload: true,
        mapName: "echartsTestProvince",
        mapProvinceName: "上海",
        isShowChild: false,
        statisticsOrganizational:{

        },// 机构数据
        statisticsYouth:{},
        reloadTime: 30000,  // ms
        type: 'allYouth',  // ms
      };
    },

    components:{
    },

    computed: {
      starsList_five() {return Array(5).fill(null).map(() => ({ checked: true }));},
      starsList_four() {return Array(4).fill(null).map(() => ({ checked: true }));},
      starsList_three() {return Array(3).fill(null).map(() => ({ checked: true }));},
    },

    mounted() {
      this.isShowChild = false;
      this.loadInfo();
      document.getElementsByTagName('html')[0].style.fontSize = '11px';
    },

    destroyed() {
      document.getElementsByTagName('html')[0].style.fontSize = '10.672358591248667vh';
    },


    methods: {
      toggleApi() {
        const that = this;
        this.$fullscreen.toggle(this.$el.querySelector(".fullscreen-wrapper"), {
          teleport: this.teleport, // 如果为true， 进入全屏时目标元素会被移动到document.body下；
          callback: (isFullscreen) => {
            that.fullscreen = isFullscreen;
          },
        });
      },
      goSchool(){
        this.$router.push({
          path: '/statisticsSchool',
        })
      },
      goSite(){
        this.$router.push({
          path: '/statisticsSiteFacilities',
        })
      },
      goKeyCity(){
        this.$router.push({
          path: '/statisticsKeyCityTrain',
        })
      },
      goData(){
        this.$router.push({
          path: '/statistics',
        })
      },
      goback(){
        this.$router.push({
          path: '/',
        })
      },
      loadInfo() {
        statistics.getSchoolOrganizational()
        .then(res => {
          this.statisticsOrganizational = res;
          this.isShowChild = true; // 开始画图
        })
        .catch((err) => {
          console.error("err", err);
        });
      },
    },
  };
</script>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable1'
  .display-wrapper
    width 100%
    height 100%
    font-size 12px !important
    background-color #101129 !important
  .display-content
    font-size 12px !important
    background-color #101129 !important
    min-width 1680px
    max-width 1920px
    margin 0 auto
    display block
    padding 10rem 0.8rem 0
    background url('../../assets/images/display/logo.png') no-repeat 0 0 / contain
    .cool-button
      padding: 3px 10px;
      font-size: 14px;
      color: white;
      border: none;
      cursor: pointer;
      background: linear-gradient(45deg, #60c5e9, #2a4d6a);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      transition: all 0.3s ease;
      transform: skew(-15deg); /* 倾斜按钮 */
      margin: 0 2px
    .cool-button:hover
      background: linear-gradient(45deg, #f9a825, #ff6b6b);
      transform: skew(-15deg) translateY(-2px); /* 保持倾斜并提升按钮位置 */
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    .cool-button-active
      padding: 3px 10px;
      font-size: 14px;
      color: white;
      border: none;
      cursor: pointer;
      background: linear-gradient(45deg, #f9a825, #ff6b6b);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      transition: all 0.3s ease;
      transform: skew(-15deg); /* 倾斜按钮 */
      margin: 0 2px
    .column
      position relative
      display flex
      justify-content space-around
      width 100%
      .row
        box-sizing border-box
        border 2px solid red
        border-image url('../../assets/images/display/border.png') 51 38 21 132
        border-width 4.125rem 1.583rem 0.875rem 5.5rem
        position relative
        margin-bottom 5rem
        color #FFFFFF
      .row-content
        position absolute
        top -4rem
        right -1.5rem
        bottom -0.875rem
        left -5.5rem
        padding 1.25rem 2rem
      .class-all
        min-height 230px
        flex: 1
        margin: 10px;
        .row-title
          color #68d8fe
          font-weight 600
          font-size 16px
          margin-bottom 0.4rem
          display flex
          align-items center
          .stars
            display flex
            margin-left 1rem
            color #ffbd57
          .btn
            display flex
            align-items center
            justify-content center
            width 7rem
            height 2rem
            font-size 0.8rem
            margin 0 5px
            border-radius 2px
            cursor pointer
          .btn-active
            background-color #0bace6
            color #FFFFFF
        .data-wrapper
          display flex
          .data-item
            flex 1
            font-size 12px
            text-align center
            .data
              font-size 26px
            .data-title
              color #4c9bfd
              margin-top 5px
          p
            word-break: break-all;
  @keyframes row
    0%, 100%
      transform translateY(-50%)
  .fullscreen-btn
    color #61a8ff
    cursor pointer
</style>

<style lang="stylus" scoped>
  .h290
    height 290px
  .echart-map-wrapper
    height 462px
    box-sizing border-box
    padding-bottom 42px
    display flex
    justify-content space-around
  .pie-wrapper
    // height 250px
    height 290px
    width 100%
  .line-wrapper
    // height 250px
    height 290px
  .grade-wrapper
    height 290px
  .login-wrapper
    // height 250px
    height 290px
</style>

<style lang="stylus">
  .select-wrapper
    .el-input__inner
      background-color rgba(0, 0, 0, 0)
      border-color #0b93d5
      color #68d8fe
  /* .el-select-dropdown */
  /* background-color #101129 !important */
  /* color #FFFFFF !important */
  /* .el-select-dropdown__item.hover, .el-select-dropdown__item:hover */
  /* background-color #101129 !important */
  /* color #FFFFFF !important */
</style>
